module.exports = __webpack_public_path__ + "static/media/builtinv2-Tele 1.22d4adb5.png";